// Gatsby requirements
import React from "react"

const Image = ({ img, loading, sizes, fullwidth }) => {

    return (
        <picture>
            <source media="(max-width: 500px)"
                srcSet={`
                    ${img.filename + '/m/500x0/filters:quality(90)'} 500w,
                    ${img.filename + '/m/400x0/filters:quality(90)'} 400w,
                    ${img.filename + '/m/300x0/filters:quality(90)'} 300w
                `}
            />
            <source media="(min-width: 501px)"
                srcSet={`
                    ${fullwidth === true && `
                        ${img.filename + '/m/2500x0/filters:quality(90)'} 2500w,
                        ${img.filename + '/m/2000x0/filters:quality(90)'} 2000w,
                        ${img.filename + '/m/1600x0/filters:quality(90)'} 1600w,
                        ${img.filename + '/m/1400x0/filters:quality(90)'} 1400w,
                    `}
                    ${img.filename + '/m/1100x0/filters:quality(90)'} 1100w,
                    ${img.filename + '/m/1000x0/filters:quality(90)'} 1000w,
                    ${img.filename + '/m/800x0/filters:quality(90)'} 800w,
                    ${img.filename + '/m/700x0/filters:quality(90)'} 700w,
                    ${img.filename + '/m/600x0/filters:quality(90)'} 600w,
                `}
            />
            <img
                sizes={sizes}
                src={img.filename}
                width={img?.filename?.split('/')[5]?.split('x')[0]}
                height={img?.filename?.split('/')[5]?.split('x')[1]}
                alt={img?.alt}
                loading={loading}
            />
        </picture>
    )
}

export default Image